var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#1794d4",
    r: 14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18 7h-2v2h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 10h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.00155 16.9414c.17089 2.9013 1.89872 7.0586 7.99845 7.0586 6.8 0 9.8333-5 10.5-7.5.8333 0 2.7-.5 3.5-2.5-.5-.5-2.5-.5-3.5 0 0-.8-.5-2.5-1.5-3-.6667.6667-1.7 2.4-.5 4-.5 1-1.8333 1-2.5 1h-13.0571c-.52948 0-.97249.4128-.94135.9414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 13h-2v2h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 13h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 13h-2v2h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 13h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 13h-2v2h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 10h-2v2h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 10h2v2h-2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocker);
export default __webpack_public_path__ + "static/media/docker.0e98a7cc3dcc1f806d88df1ba58d2d2b.svg";
export { ForwardRef as ReactComponent };